<!--
 * @创建文件时间: 2020-06-28 17:13:33
 * @最后修改人: lfq
 * @最后修改时间: 2020-07-10 11:46:50
 * @联系Qq:1360484677
 * @文件介绍: 新版字典组件
--> 
<template>
  <el-form-item
    :label="form.name"
    :prop="form.model"
    :class="[form.options.required?'label-blue':'']"
    :rules="form.rules"
    :required="form.options.required"
    v-show="!form.options.hidden"
    style="padding-left:10px;line-height:36px;"
  >
    
    
    
    <div v-if="form.treeOrSelect">
      <el-select style="width:226px" :disabled="inputDisable" v-model="value[form.model]" filterable :filter-method="filterSelect" @focus="getPro"  :placeholder="form.options.placeholder" @clear="clear" ref="selectReport" clearable>
      <el-option :label="value[form.model]" :value="value[form.model]" style="width: 380px;height:auto;background-color:#fff;padding: 0px;">
       <el-tree
       ref="tree"
        style="width:100%;"
        :data="optionData"
       :filter-node-method="filterNode"
        node-key="rowCode"
        :props="{label:'name',children:form.options.props.children}">
          <span class="custom-tree-node" slot-scope="{node,data}">
            <span>
              <span v-if="form.showBr">{{data.name+(data.unit==null?'':('   ('+data.unit+')'))}}</span>
              <span v-else>{{data.name}}</span>
            </span>
            <!--  -->
            <span>
              <el-button
                type="text"
                size="mini"
                @click="() => nodeClick(data)">
                选择
              </el-button>
            </span>
          </span>
        </el-tree>
      </el-option>
      </el-select>
    </div>
    <div v-else>
      <el-select  ref="selectRef"
                v-model="value[form.model]"
               :placeholder="form.options.placeholder"
               :disabled="inputDisable"
               :clearable="!form.options.clearable"
               :multiple="form.options.multiple"
                @change="onInput"
               style="width:226px"
               :type="form.options.dataType"
               :filterable="form.options.remoteSearch"
               :allow-create="form.options.allowCreate"
               :loading="loading"
               value="">
      <el-option
        v-for="item in optionData"
        :key="item[form['options']['props']['value']]"
        :label="item[form['options']['props']['label']]"
        :value="item[form['options']['props']['value']]">
      </el-option>
      </el-select>
    </div>
      
  
  </el-form-item>
</template>

<script>
export default {
  name: "ProjectTree",
  // components: {},,expandTrigger:'hover' this.$refs.org.dropDownVisible=false;
  data() {
    return {
      loading: false,
      key: "",
      mainValue: [],
      optionData: [],
      dialogVisible: false,
      filterText: "",
    };
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          name: "",
          prop: "",
          icon: "",
          className: "",
          options: {
            defaultValue: [],
            width: "",
            placeholder: "",
            disabled: false,
            clearable: false,
            remote: true,
            remoteOptions: [],
            props: {
              value: "value",
              label: "label",
              children: "children"
            },
            customClass: "",
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true, 
            showLast: false,
            remoteFunc: () => {},
            remoteSearch: false,
            remoteSearchFunc: () => {}
          },
          key: "",
          model: "value",
          modelLabel: [],
          searchForm:{},
          treeOrSelect: false,
          showBr: false,
          rules: [{}]
        };
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    value: {
      immediate: true,
      handler(val) {
        this.mainValue = val;

      }
    },
    "form.searchForm": function(newVal, oldVal) {
      let urls="";
      if(this.form.treeOrSelect){
        urls=this.$url.dictionays.getintegratedictionarytree;
      }else{
        urls=this.$url.dictionays.getintegratedictionarylist;
      }
      this.$http.postX(urls, this.form.searchForm).then(res => {
        this.optionData=res.data;
      });
    },
  },
  methods: {
    filterSelect(value){
      this.filterText = value
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getPro() {
      // this.optionData=this.form.selectData;
    },
    //节点被点击
    nodeClick(data, checked, event) {
      // if(data.children.length>0){}else{
        this.value[this.form.model] = data[this.form.options.props.value];
        let lists=this.form.modelLabel;
        lists.forEach(element => {
            let bs=element.split(",");
            this.value[bs[0]]=data[bs[1]];
        });
        this.$refs.selectReport.blur()
      // }
    },
    onInput(){
      let that=this;
      if(this.value[this.form.model]!=""){
        let obj = {};
        if(this.optionData.length!==0){
          obj = this['optionData'].find(function(item) { //obj是选中的对象
              return item['name'] === that.value[that.form.model];
          });
          let lists=this.form.modelLabel;
          lists.forEach(element => {
            let bs=element.split(",");
            this.value[bs[0]]=obj[bs[1]];
          });
        }
      }else{
        let lists=this.form.modelLabel;
        lists.forEach(element => {
          let bs=element.split(",");
          this.value[bs[0]]="";
        });
      }
        
    },
    clear(){
         this.value[this.form.model] = "";
          let lists=this.form.modelLabel;
          lists.forEach(element => {
              let bs=element.split(",");
              this.value[bs[0]]="";
          });
         this.filterText = ""
    },
  },
  created() {
    if (this.form.treeOrSelect === undefined) {
      this.form.treeOrSelect = false;
    }
  },
  mounted() {
    let that = this;
    that.$emit("init", that.key, that);
    setInterval(function() {
      document.querySelectorAll(".el-cascader-node__label").forEach(el => {
        el.onclick = function() {
          if (this.previousElementSibling) this.previousElementSibling.click();
        };
      });
    }, 1000);
    let urls="";
    if(this.form.treeOrSelect){
      urls=this.$url.dictionays.getintegratedictionarytree;
    }else{
      urls=this.$url.dictionays.getintegratedictionarylist;
    }
    this.$http.postX(urls, that.form.searchForm).then(res => {
      this.optionData=res.data;
    });
  },
  computed: {
    inputDisable() {
      return this.disabled || this.form.options.disabled;
    }
  }
};
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 8px;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/newDictionary2.vue"
}
</vue-filename-injector>
